(() => {
  const init = (root = document) => root.querySelectorAll('[data-cs-organic-world]').forEach(page => {
    if (page.dataset.olReady) return;
    page.dataset.olReady = 'true';
    page.querySelectorAll('[data-ol-step]').forEach(button => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      const current = Number.parseInt(input.value, 10) || 1;
      input.value = Math.max(1, Math.min(99, current + Number(button.dataset.olStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    page.querySelector('[data-ol-variant]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      const buy = event.target.closest('.ol-buy');
      buy.querySelector('[data-ol-price]').textContent = option.dataset.price;
      const compare = buy.querySelector('[data-ol-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      const submit = buy.querySelector('[data-ol-submit]');
      submit.disabled = option.dataset.available !== 'true';
      submit.textContent = submit.disabled ? submit.dataset.soldLabel : submit.dataset.availableLabel;
    });
  });
  init();
  document.addEventListener('shopify:section:load', () => init());
})();
